"use client";
import AppSelect from "@/components/common/AppSelect";


const formatToman = (value) => `${Number(value || 0).toLocaleString("fa-IR")} تومان`;
const formatNumber = (value) => Number(value || 0).toLocaleString("fa-IR");

export default function HologramCalculatorForm({
  options = {},
  value,
  onChange,
  quantity,
  onQuantityChange,
  showQuantityInput = false,
  quantityLabel = "تعداد / تیراژ",
  quantityHelper = "تعداد را به‌صورت عدد صحیح بزرگ‌تر از صفر وارد کنید.",
  quantityBadge = "",
  resultTitle = "جمع هولوگرام",
  resultDescription = "محاسبه براساس تنظیمات انتخاب‌شده",
  loading = false,
  totalPriceToman,
  unitPriceToman,
  error = "",
}) {
  const sizes = options.sizes || [];
  const sheetTypes = options.sheet_types || [];
  const serialTypes = options.serial_types || [];
  const templateTypes = options.template_types || [];
  const voidTypes = options.void_types || [];
  const hasOptions =
    sizes.length > 0 &&
    sheetTypes.length > 0 &&
    serialTypes.length > 0 &&
    templateTypes.length > 0 &&
    voidTypes.length > 0;

  return (
    <div className="rounded-[1.6rem] border border-accent/15 bg-white/85 p-4 shadow-lg sm:rounded-[2rem] sm:p-5">
      <div className="flex flex-col gap-2 md:flex-row md:items-end md:justify-between">
        <div>
          <h2 className="font-Dana-Bold text-lg text-primary sm:text-xl">تنظیمات ماشین حساب هولوگرام</h2>
          {showQuantityInput && (
            <p className="mt-2 text-sm leading-7 text-primary/65">
              سایز، فویل، سریال، قالب و تعداد را وارد کنید تا قیمت لحظه‌ای محاسبه شود.
            </p>
          )}
        </div>
        {quantityBadge && (
          <span className="rounded-full bg-accent/10 px-4 py-2 text-xs text-accent">
            {quantityBadge}
          </span>
        )}
      </div>

      {!hasOptions ? (
        <p className="mt-5 rounded-2xl border border-tertiary/20 bg-tertiary/10 p-4 text-sm leading-7 text-tertiary" role="status">
          گزینه‌های ماشین حساب هولوگرام برای نمایش آماده نیست.
        </p>
      ) : (
        <>
          <div className="mt-5 grid gap-4 md:grid-cols-2 xl:grid-cols-3">
            {showQuantityInput && (
              <label className="block text-sm font-Dana-Medium text-primary">
                {quantityLabel}
                <input
                  type="number"
                  min="1"
                  step="1"
                  inputMode="numeric"
                  value={quantity}
                  onChange={(event) => onQuantityChange?.(event.target.value)}
                  className={`mt-2 h-12 w-full rounded-2xl border bg-white px-4 outline-none focus:ring-4 ${
                    error ? "border-tertiary/50 focus:ring-tertiary/20" : "border-primary/15 focus:ring-secondary/20"
                  }`}
                  aria-describedby="hologram-quantity-helper"
                  aria-invalid={Boolean(error)}
                />
                <span id="hologram-quantity-helper" className="mt-2 block text-xs leading-6 text-primary/60">
                  {quantityHelper}
                </span>
              </label>
            )}

            <label className="block text-sm font-Dana-Medium text-primary">
              سایز هولوگرام
              <AppSelect
                className="mt-2 h-12 w-full rounded-2xl border border-primary/15 bg-white px-4 outline-none focus:ring-4 focus:ring-secondary/20"
                value={value.size}
                onChange={(event) => onChange("size", event.target.value)}
              >
                {sizes.map((item) => (
                  <option key={item.size} value={item.size}>
                    {item.size}
                  </option>
                ))}
              </AppSelect>
            </label>

            <fieldset className="text-sm md:col-span-2 xl:col-span-1">
              <legend className="mb-2 font-Dana-Medium text-primary">نوع فویل</legend>
              <div className="grid grid-cols-3 gap-2">
                {sheetTypes.map((item) => (
                  <label
                    key={item.code}
                    className={`flex min-h-12 cursor-pointer items-center justify-center rounded-2xl border px-3 py-3 text-center transition hover:-translate-y-0.5 focus-within:ring-4 focus-within:ring-secondary/20 ${
                      value.sheet_type === item.code
                        ? "border-secondary bg-secondary/10 text-secondary shadow-sm"
                        : "border-primary/10 bg-white text-primary/70"
                    }`}
                  >
                    <input
                      type="radio"
                      name="hologram_sheet_type"
                      className="sr-only"
                      checked={value.sheet_type === item.code}
                      onChange={() => onChange("sheet_type", item.code)}
                    />
                    <span>{item.title_fa}</span>
                  </label>
                ))}
              </div>
            </fieldset>

            <label className="block text-sm font-Dana-Medium text-primary">
              نوع سریال
              <AppSelect
                className="mt-2 h-12 w-full rounded-2xl border border-primary/15 bg-white px-4 outline-none focus:ring-4 focus:ring-secondary/20"
                value={value.serial_type}
                onChange={(event) => onChange("serial_type", event.target.value)}
              >
                {serialTypes.map((item) => (
                  <option key={item.code} value={item.code}>
                    {item.title_fa}
                  </option>
                ))}
              </AppSelect>
            </label>

            <label className="block text-sm font-Dana-Medium text-primary">
              نوع قالب
              <AppSelect
                className="mt-2 h-12 w-full rounded-2xl border border-primary/15 bg-white px-4 outline-none focus:ring-4 focus:ring-secondary/20"
                value={value.template_type}
                onChange={(event) => onChange("template_type", event.target.value)}
              >
                {templateTypes.map((item) => (
                  <option key={item.code} value={item.code}>
                    {item.title_fa}
                  </option>
                ))}
              </AppSelect>
            </label>

            <label className="block text-sm font-Dana-Medium text-primary">
              زیرلایه
              <AppSelect
                className="mt-2 h-12 w-full rounded-2xl border border-primary/15 bg-white px-4 outline-none focus:ring-4 focus:ring-secondary/20"
                value={value.void_type}
                onChange={(event) => onChange("void_type", event.target.value)}
              >
                {voidTypes.map((item) => (
                  <option key={item.code} value={item.code}>
                    {item.title_fa}
                  </option>
                ))}
              </AppSelect>
            </label>
          </div>

          {error && (
            <p className="mt-4 rounded-2xl border border-tertiary/25 bg-tertiary/10 p-3 text-sm leading-7 text-tertiary" role="alert">
              {error}
            </p>
          )}

          <section className="mt-5 rounded-[1.5rem] border border-accent/20 bg-accent/10 p-4" aria-live="polite">
            <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
              <div>
                <h3 className="font-Dana-Bold text-base text-primary">{resultTitle}</h3>
                <p className="mt-1 text-xs leading-6 text-primary/60">{resultDescription}</p>
              </div>
              <div className="text-right sm:text-left">
                <strong className="block font-Dana-Bold text-xl text-accent">
                  {loading ? "در حال محاسبه…" : Number.isFinite(totalPriceToman) ? formatToman(totalPriceToman) : "در انتظار محاسبه"}
                </strong>
                <span className="mt-1 block text-xs text-primary/60">
                  هر عدد: {loading ? "…" : Number.isFinite(unitPriceToman) ? formatToman(unitPriceToman) : "—"}
                </span>
                {showQuantityInput && (
                  <span className="mt-1 block text-xs text-primary/60">
                    تعداد: {formatNumber(quantity)}
                  </span>
                )}
              </div>
            </div>
          </section>
        </>
      )}
    </div>
  );
}
